var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewOnlyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 6.0625C17.9375 6.1875 17.9688 6.375 17.9688 6.5C17.9688 6.65625 17.9375 6.84375 17.875 6.96875C16.1875 10.2812 12.8125 12.5 9 12.5C5.15625 12.5 1.78125 10.2812 0.09375 6.96875C0.03125 6.84375 0 6.65625 0 6.53125C0 6.375 0.03125 6.1875 0.09375 6.0625C1.78125 2.75 5.15625 0.5 9 0.5C12.8125 0.5 16.1875 2.75 17.875 6.0625ZM9 11C11.4688 11 13.5 9 13.5 6.53125V6.5C13.5 4.03125 11.4688 2 9 2C6.5 2 4.5 4.03125 4.5 6.5C4.5 9 6.5 11 9 11ZM9 3.5C10.6562 3.5 12 4.84375 12 6.5C12 8.15625 10.6562 9.5 9 9.5C7.34375 9.5 6 8.15625 6 6.5C6 6.28125 6.03125 5.9375 6.09375 5.71875C6.3125 5.875 6.71875 6 7 6C7.8125 6 8.5 5.34375 8.5 4.53125C8.5 4.25 8.34375 3.84375 8.1875 3.625C8.40625 3.5625 8.75 3.53125 9 3.5Z",
    fill: "#3C2212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewOnlyIcon);
export default __webpack_public_path__ + "static/media/view-only-icon.d2b3c3b739a6f96ed142feff542556ed.svg";
export { ForwardRef as ReactComponent };